import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment'

import { Button } from 'react-bootstrap'
import { ListItem } from '~/views'

import S from './TemplatesScreen.css'

export default class TemplateItem extends React.Component {
  
  static REMOVE_EVENT = 'removeTemplate';

  static SELECTED = 'select';

  static propTypes = {
    item : PropTypes.object.isRequired,
    onEvent : PropTypes.func,
    selected : PropTypes.bool
  }

  onEvent = ( event ) => {
    if ( this.props.onEvent ) { 
      this.props.onEvent( event, this.props.item );
    }
  }

  render() {
    const { item : script, hideNavButtons } = this.props;
    return (
      <ListItem className={S.scriptItem} 
        onEvent={this.onEvent}
        item={script}
        selected={this.props.selected}
        title={script.name}
        subtitle={moment( script.lastModified ).fromNow()}
        leftView={this.renderLeft( script )}
        rightView={this.renderRight( script, hideNavButtons )} />
    )
  }

  renderLeft() {
    return null
  }

  renderRight( script, hideNavButtons ) {

    return (
      <div>
        <Button bsStyle="link"
          bsSize="large"
          className={S.delete} 
          onClick={() => { this.onEvent( TemplateItem.REMOVE_EVENT ) }}> 
          <i className="fa fa-trash-o" />
        </Button>

      </div>
    )
  }

}
